

export default class {

    static isValid(expense) {
        if(expense.optional && expense.value == 0)
            return true

        if(this.isInRange(expense))
            return true

        if(expense.explanation.length > 3)
            return true
    }

    static isInRange(expense) {
        
        if(expense.name == 'Other')
            return false
        return (
            !this.isOverRange(expense) && !this.isUnderRange(expense)
        )
    }

    static isOverRange(expense) {
        return expense.value > (expense.expectedValue * 1.3 + 50)
    }

    static isUnderRange(expense) {
        const result = expense.value < (expense.expectedValue * .8 - 50)
        return result
    }
        
}


// WEBPACK FOOTER //
// ./src/pages/LivingExpenses/LivingExpenseHelpers.js